// extracted by mini-css-extract-plugin
module.exports = {"icon":"OrderControl__icon___2mB41","span":"OrderControl__span___2hdVU","selected":"OrderControl__selected___3N05P","select":"OrderControl__select___rhnCP"};